import { miniSerializeError, SerializedError } from '@reduxjs/toolkit';
import { ServerError } from 'src/types';

import { ServerErrorAdapter } from '@itm/shared-frontend/lib/utils';

export const serializeError = (e: unknown): SerializedError => {
  const message = new ServerErrorAdapter(e as ServerError).combine().join('\n  ');
  return miniSerializeError({ message });
};
